import retry from './retry';
import timeout from './timeout';
import globalMemoAsync from './globalMemoAsync';

export const retryWithTimeout = (asyncAction) => retry({
  asyncAction: () => timeout({ asyncAction }),
});

export const memoizedRetryWithTimeout = (cacheName, inputs, wrappedFn) => (
  globalMemoAsync({
    globalObject: window,
    cacheName,
    inputs,
  })(() => (
    retryWithTimeout(wrappedFn)
  ))
);
